function Footer() {
  return (
    <footer className="bg-white shadow-inner py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} Member Management System. All rights reserved.
            </p>
          </div>
          
          <div className="flex space-x-6">
            <a href="#" className="text-gray-600 hover:text-blue-600">
              <span className="sr-only">Terms of Service</span>
              <span className="text-sm">Terms of Service</span>
            </a>
            <a href="#" className="text-gray-600 hover:text-blue-600">
              <span className="sr-only">Privacy Policy</span>
              <span className="text-sm">Privacy Policy</span>
            </a>
            <a href="#" className="text-gray-600 hover:text-blue-600">
              <span className="sr-only">Contact Us</span>
              <span className="text-sm">Contact Us</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;